import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import logo from "../../assets/ledgerflow-logo-icon.png";

const defaultText = {
  budgets: "Create budgets",
  getStarted: "Get Started",
  goals: "Reach your goals",
  intro: "A focused workspace for tracking spending, planning budgets, and building better financial habits.",
  title: "Welcome to LedgerFlow",
  track: "Track expenses"
};

export default function OnboardingDialog({ onClose, t = defaultText }) {
  const labels = { ...defaultText, ...t };
  const steps = [
    { icon: "k-i-dollar", title: labels.track },
    { icon: "k-i-gauge", title: labels.budgets },
    { icon: "k-i-check-target", title: labels.goals }
  ];

  return (
    <Dialog title={labels.title} onClose={onClose} width={560}>
      <div className="onboarding-panel">
        <img src={logo} alt="" />
        <p>{labels.intro}</p>
        <div className="onboarding-steps">
          {steps.map((step) => (
            <article key={step.title}>
              <span className={`k-icon ${step.icon}`} aria-hidden="true" />
              <strong>{step.title}</strong>
            </article>
          ))}
        </div>
      </div>
      <DialogActionsBar>
        <Button themeColor="primary" icon="check" onClick={onClose}>
          {labels.getStarted}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}
